import { Component } from '@verndale/core'

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $toggleButton: this.el.querySelector('.accordion-item__button'),
      $description: this.el.querySelector('.accordion-item__description'),
      $minus: this.el.querySelector('.accordion-item__button-minus'),
      $plus: this.el.querySelector('.accordion-item__button-plus'),
      $faq: this.el.querySelector('.accordion-item__faq'),
      $headingContainer: this.el.querySelector('.accordion-item__heading-container')
    }
    if (this.dom.$faq) {
      this.hideClass = 'accordion-item__description--hide-faq'
    } else {
      this.hideClass = 'accordion-item__description--hide'
    }
  }

  addListeners() {
    this.dom.$headingContainer.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick() {
    if (!this.dom.$description.classList.contains(this.hideClass)) {
      this.dom.$toggleButton.setAttribute('aria-expanded', false)
    } else {
      this.dom.$toggleButton.setAttribute('aria-expanded', true)
    }
    this.dom.$description.classList.toggle(this.hideClass)
  }
}

export default Module
